import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  INpsFeedbackFormValues,
  IUseNpsFeedbackExplanation,
  IUseNpsFeedbackExplanationFormProps
} from "./nps-feedback-explanation-form.types";

const FormSchema = yup.object().shape({
  comment: yup
    .string()
    .min(1, "Nulisnya minimal 1 karakter, ya.")
    .max(250, "Nulisnya maksimal 250 karakter, ya.")
    .required()
});

export const useNpsFeedbackExplanationForm = ({
  submitFeedbackExplanationForm,
  handleModalClose
}: IUseNpsFeedbackExplanationFormProps): IUseNpsFeedbackExplanation<INpsFeedbackFormValues> => {
  const {
    control,
    getValues,
    handleSubmit,
    formState: { isValid }
  } = useForm<INpsFeedbackFormValues>({
    defaultValues: {
      comment: ""
    },
    resolver: yupResolver(FormSchema),
    mode: "onChange"
  });

  const handleFeedbackSubmission = (): void => {
    const { comment } = getValues();
    submitFeedbackExplanationForm(comment);
  };

  const handleSkip = (): void => {
    const { comment } = getValues();
    handleModalClose(comment);
  };

  return {
    handleSubmit,
    handleSkip,
    handleFeedbackSubmission,
    isValid,
    control
  };
};
